// extracted by mini-css-extract-plugin
export default {"onboardingWrapper":"style-onboardingWrapper-MKuR2"};